import { EditPetProfile } from "../../features/account_settings/components/pets/EditPetProfile";

const EditPetPage = () => {
  return <EditPetProfile />
};
export default EditPetPage;